import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
export function selectTestModeCookieState(state: IApplicationState): boolean {
  return state.cookies.testMode;
}
